import RankingBase from '../components/base/ranking-base';
import React from 'react';

const TourneysComponentsFormRulesPartRanking = () => {
  return <RankingBase sportType="general" />;
};

export default TourneysComponentsFormRulesPartRanking;
